import CommonService from './CommonService';

export const commonService = new CommonService();
export default commonService;
